<app-modal class="more-actions-modal" [(visible)]="visible" (onCancel)="cancel()" header="WARNING">
    <p>{{ message }}</p>

    <footer>
      <app-button class="header-button" text="Continue" (onClick)="onContinue()" ></app-button>
    </footer>
  </app-modal>
  
  
  